import { createAction, props } from "@ngrx/store"
import { Bank } from "app/modules/products/_state/products.interfaces"
import { EditRecipientDto, RecipientCategoryDto, RecipientDto, UpdateTransactionStatusDto } from "./bulk-pay.dtos"
import { Country, Recipient, RecipientCategory, XcelAccount } from "./bulk-pay.interfaces"

export const fetchCountries = createAction(
    '[Bulk Pay Module] fetch countries'
)

export const fetchCountriesFailed = createAction(
    '[Bulk Pay Module] STATUS: fetch countries failed'
)

export const fetchCountriesSuccess = createAction(
    '[Bulk Pay Module] STATUS: fetch countries success',
    props<{countries: Country[]}>()
)


export const fetchRecipientCategories = createAction(
  '[BulkPay] Fetch Recipient Categories',
  props<{ 
    page: number; 
    limit: number;
    search?: string;
    startDate?: string;
    endDate?: string;
  }>()
);
  
  

export const fetchRecipientCategoriesFailed = createAction(
    '[Bulk Pay Module] STATUS: fetch recipient categories failed'
)

export const fetchRecipientCategoriesSuccess = createAction(
    '[Bulk Pay Module] STATUS: fetch recipient categories success',
    props<{recipientCategories: RecipientCategory[]; pagination: any}>()
)


export const createRecipientCategory = createAction(
    '[Bulk Pay Module] create recipient category',
    props<{recipientCategoryDto: RecipientCategoryDto}>()
)

export const createRecipientCategoryFailed = createAction(
    '[Bulk Pay Module] STATUS: create recipient category failed'
)

export const createRecipientCategorySuccess = createAction(
  '[Bulk Pay Module] STATUS: create recipient category success',
  props<{ category_id: string; category: string; merchant_id: string; env: string }>()
);


export const fetchRecipients = createAction(
    '[Bulk Pay Module] fetch recipients'
)

export const fetchRecipientsFailed = createAction(
    '[Bulk Pay Module] STATUS: fetch recipients failed'
)

export const fetchRecipientsSuccess = createAction(
    '[Bulk Pay Module] STATUS: fetch recipients success',
    props<{recipients: Recipient[]}>()
)


export const fetchRecipientsByCategory = createAction(
    '[Bulk Pay Module] fetch recipients by category',
    props<{categoryId: string}>()
)

export const fetchRecipientsByCategoryFailed = createAction(
    '[Bulk Pay Module] STATUS: fetch recipients by category failed'
)

export const fetchRecipientsByCategorySuccess = createAction(
    '[Bulk Pay Module] STATUS: fetch recipients by category success',
    props<{recipients: Recipient[]}>()
)


export const createRecipient = createAction(
    '[Bulk Pay Module] create recipient',
    props<{recipientDto: RecipientDto}>()
)

export const createRecipientFailed = createAction(
    '[Bulk Pay Module] STATUS: create recipient failed'
)

export const createRecipientSuccess = createAction(
    '[Bulk Pay Module] STATUS: create recipient success'
)


export const editRecipient = createAction(
    '[Bulk Pay Module] edit recipient',
    props<{recipientDto: EditRecipientDto}>()
)

export const editRecipientFailed = createAction(
    '[Bulk Pay Module] STATUS: edit recipient failed'
)

export const editRecipientSuccess = createAction(
    '[Bulk Pay Module] STATUS: edit recipient success'
)


export const validateXcelAccount = createAction(
    '[Bulk Pay Module] validate xcel account',
    props<{walletNumber: string, schemeCode: string}>()
)

export const validateXcelAccountFailed = createAction(
    '[Bulk Pay Module] STATUS: validate xcel account failed'
)

export const validateXcelAccountSuccess = createAction(
    '[Bulk Pay Module] STATUS: validate xcel account success',
    props<{xcelAccount: XcelAccount}>()
)


export const fetchAccountBalance = createAction(
    '[Bulk Pay Module] fetch account balance',
    props<{accountIdentifier: string}>()
)

export const fetchAccountBalanceFailed = createAction(
    '[Bulk Pay Module] STATUS: fetch account balance failed'
)

export const fetchAccountBalanceSuccess = createAction(
    '[Bulk Pay Module] STATUS: fetch account balance success',
    props<{balance}>()
)


export const sendOTP = createAction(
    '[Bulk Pay Module] send OTP',
    props<{accountIdentifier: string}>()
)

export const sendOTPFailed = createAction(
    '[Bulk Pay Module] STATUS: send OTP failed'
)

export const sendOTPSuccess = createAction(
    '[Bulk Pay Module] STATUS: send OTP success',
    props<{otpInfo}>()
)


export const deleteRecipient = createAction(
    '[Bulk Pay Module] delete recipient',
    props<{recipientId: string}>()
)

export const deleteRecipientFailed = createAction(
    '[Bulk Pay Module] STATUS: delete recipient failed'
)

export const deleteRecipientSuccess = createAction(
    '[Bulk Pay Module] STATUS: delete recipient success'
)

export const updateTransactionStatus = createAction(
    '[Bulk Pay Module] update transaction status',
    props<{ updateTransactionStatusDto: UpdateTransactionStatusDto | [], transactionId: string, paymentId: string, status: string}>()
)

export const updateTransactionStatusFailed = createAction(
    '[Bulk Pay Module] STATUS: update transaction status failed'
)

export const updateTransactionStatusSuccess = createAction(
    '[Bulk Pay Module] STATUS: update transaction status success'
)

export const fetchRecipientBanks = createAction(
    '[Products Module] fetch recipient banks',
    props<{countryCode: string}>()
)

export const fetchRecipientBanksFailed = createAction(
    '[Products Module] STATUS: fetch recipient banks failed'
)

export const fetchRecipientBanksSuccess = createAction(
    '[Products Module] STATUS: fetch recipient banks success',
    props<{banks: Bank[]}>()
)